/**
bundle_name required
  bundle_class required
  sold required
  bundle_discount required
  bundle_components required
  in side bundle_components: 
      id required
          price required
          qty optional
free_components optional
  if you have free_components params inside it are required
    id required
          price required
**/
var upsell_limit_bundles = 3;


var bundles_array = [
  {
    bundle_name: 'Beginner Kit',
    bundle_class: 'Beginner_Kit',
    sold: false,
    bundle_discount: 38.5844749,
    bundle_components: [
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 28922827112541, price:15.00}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ]
  }, 
  {
    bundle_name: 'Ultimate Bundle',
    bundle_class: 'Ultimate_Bundle',
    sold: false,
    bundle_discount: 62.6801153,
    bundle_components: [
      {id: 28922827112541, price:15.00}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price: 195.00}, // MasterBlaster™
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39309566869597, price:99.00} // Ashley Black's Kryomat™ Small
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 39293778460765, // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation 
      price:25.00}]
  }
  },
  {
    bundle_name: 'Budget Box',
    bundle_class: 'Budget_Box',
    sold: false,
    bundle_discount: 38.1625442,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 28922827112541, price:15.00}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ]
  },
  {
      bundle_name: 'The Starter Kit',
      bundle_class: 'The_Starter_Kit',
      sold: false,
      bundle_discount: 38.1625442,
      bundle_components: [
        {id: 39412991656029, price:115.00}, // Mini 2™
        {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price:115.00}, // FaceBlaster™
        {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
        {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      ]
    },
  {
    bundle_name: 'Bronze Beginner Kit',
    bundle_class: 'Beginners-Corner-Small',
    sold: false,
    bundle_discount: 35.4948805,
    bundle_components: [
   {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
  {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
  {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
  {id: 39293778460765, price:25.00} // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation
], free_components: {
  bundle_percentage: 100,
  free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
  price:15.00}]
    }
  },
  {
    bundle_name: 'Silver Beginner Kit',
    bundle_class: 'Beginners-Corner-Medium',
    sold: false,
    bundle_discount: 46.2655602,
    bundle_components: [
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39330949726301, price:59.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00},{id: 39293778460765, price:25.00} ] // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation 
    }
  },
  {
    bundle_name: 'Gold Beginner Kit',
    bundle_class: 'Beginners-Corner-Large',
    sold: false,
    bundle_discount: 55.1810237,
    bundle_components: [
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price: 195.00}, // MasterBlaster™
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39309566869597, price:99.00}, // Ashley Black's Kryomat™ Small
      {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
      {id: 39330949726301, price:59.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 39293778460765, price:25.00} // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
    bundle_name: 'Bronze Muscles Kit',
    bundle_class: 'Muscles-Recovery-Small',
    sold: false,
    bundle_discount: 38.8349515,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 32996096737373, price:79.00} // Ashley Black's KryoPack™ Back & Abs Wrap
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
    bundle_name: 'Silver Muscles Kit',
    bundle_class: 'Muscles-Recovery-Medium',
    sold: false,
    bundle_discount: 46.1916462,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39309566869597, price:99.00}, // Ashley Black's Kryomat™ Small
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
    bundle_name: 'Gold Muscles Kit',
    bundle_class: 'Muscles-Recovery-Large',
    sold: false,
    bundle_discount: 50.4261364,
    bundle_components: [
      {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price: 195.00}, // MasterBlaster™
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39309566869597, price:99.00}, // Ashley Black's Kryomat™ Small
      {id: 39293778460765, price:25.00} // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
    bundle_name: 'Bronze Face Kit',
    bundle_class: 'Face-Neck-Small',
    sold: false,
    bundle_discount: 36.0515021,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39330949726301, price:59.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 39330949791837, price:59.00} // Ashley Black's Kryopack™ Eye Wrap
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
    bundle_name: 'Silver Face Kit',
    bundle_class: 'Face-Neck-Medium',
    sold: false,
    bundle_discount: 42.2018349,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39330949726301, price:59.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
    bundle_name: 'Gold Face Kit',
    bundle_class: 'Face-Neck-Large',
    sold: false,
    bundle_discount: 50.8802817,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price: 195.00}, // MasterBlaster™
      {id: 39293778460765, price:25.00}, // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation
      {id: 39330949726301, price:59.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 39330949791837, price:59.00} // Ashley Black's Kryopack™ Eye Wrap
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
    bundle_name: 'Bronze Hair Kit',
    bundle_class: 'Hair-Small',
    sold: false,
    bundle_discount: 35.9861592,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39330949726301, price:59.00} // Ashley Black's Kryopack™ Face Wrap
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: []
  }
  },
  {
    bundle_name: 'Silver Hair Kit',
    bundle_class: 'Hair-Medium',
    sold: false,
    bundle_discount: 40.4255319,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39330949726301, price:59.00} // Ashley Black's Kryopack™ Face Wrap
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: []
  }
  },
  {
    bundle_name: 'Gold Hair Kit',
    bundle_class: 'Hair-Large',
    sold: false,
    bundle_discount: 50.8226691,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price: 195.00}, // MasterBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39330949726301, price:59.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 39293778460765, price:25.00}, // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: []
  }
  },
  {
    bundle_name: 'Bronze Skin and Cellulite Kit',
    bundle_class: 'Skin-and-Cellulite-Small',
    sold: false,
    bundle_discount: 35.4948805,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
      {id: 39293778460765, price:25.00} // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
    bundle_name: 'Silver Skin and Cellulite Kit',
    bundle_class: 'Skin-and-Cellulite-Medium',
    sold: false,
    bundle_discount: 41.5816327,
    bundle_components: [
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
      {id: 39330949726301, price:59.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 39293778460765, price:25.00} // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
    bundle_name: 'Gold Skin and Cellulite Kit',
    bundle_class: 'Skin-and-Cellulite-Large',
    sold: false,
    bundle_discount: 50.4261364,
    bundle_components: [
      {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price: 195.00}, // MasterBlaster™
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39309566869597, price:99.00}, // Ashley Black's Kryomat™ Small
      {id: 39293778460765, price:25.00} // The Cellulite Myth Daily Companion Guide: Your 12-Week Journey to Transformation
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 28922827112541, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      price:15.00}]
    }
  },
  {
  bundle_name: 'BodyBlasting Duo',
  bundle_class: 'BodyBlasting_Duo',
  sold: false,
  bundle_discount: 26.2345679,
  bundle_components: [
    {id: 39309911425117, price:249.00}, // PaddleBlaster™
    {id: 39412930019421, price:199.00} // Savage Blaster
  ]
},
{
  bundle_name: 'Full-Body Blast Kit',
  bundle_class: 'full_body_blast_kit',
  sold: false,
  bundle_discount: 29.3963255,
  bundle_components: [
    {id: 39309911425117, price:249.00}, // PaddleBlaster™
    {id: 39412930019421, price:199.00}, // Savage Blaster
    {id: 39309566869597, price:99.00} // Ashley Black's Kryomat™ Small
  ]
},
  {
  bundle_name: 'Hair Kit',
  bundle_class: 'Hair_Kit',
  sold: false,
  bundle_discount: 20.7612457,
  bundle_components: [
    {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
    {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
    {id: 39330949726301, price:59.00} // Ashley Black's Kryopack™ Face Wrap
  ]
},
 {
  bundle_name: 'Pain Kit',
  bundle_class: 'Pain_Kit',
  sold: false,
  bundle_discount: 53.12,
  bundle_components: [
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00}, // FasciaBlaster® Nugget
      {id: 39330949922909, price:249.00}, // Ashley Black's Kryomat™ Medium
      {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
  ]
},
 {
  bundle_name: 'Budget_Box',
  bundle_class: 'Budget_Box',
  sold: false,
  bundle_discount: 52.2968198,
  bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 28922827112541, price:15.00}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
  ]
},
 {
  bundle_name: 'Abs Challenge Kit',
  bundle_class: 'Abs_Challenge_Kit',
  sold: false,
  bundle_discount: 30,
  bundle_components: [
      {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price:195}, // MasterBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 32996096737373, price:79.00} // Ashley Black's KryoPack™ Back & Abs Wrap
  ]
},
{
  bundle_name: 'Stubborn Belly Fat Kit',
  bundle_class: 'Stubborn_Belly_Fat_Kit',
  sold: false,
  bundle_discount: 30,
  bundle_components: [
      {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price:195}, // MasterBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 32996096737373, price:79.00} // Ashley Black's KryoPack™ Back & Abs Wrap
  ]
},
 {
  bundle_name: 'KryoKit',
  bundle_class: 'KryoKit',
  sold: false,
  bundle_discount: 44.6700508,
  bundle_components: [
    {id: 39330949726301, price:59.00}, // Ashley Black's Kryopack™ Face Wrap
    {id: 32994645409885, price:59.00}, // Ashley Black's KryoPack™ Wrap
    {id: 32996096737373, price:79.00} // Ashley Black's KryoPack™ Back & Abs Wrap
  ]
},
 {
  bundle_name: 'Snatched Waist Kit',
  bundle_class: 'Snatched_Waist_Kit',
  sold: false,
  bundle_discount: 20.5128205,
  bundle_components: [
    {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price:195} // MasterBlaster™
  ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 32996096737373, price:79.00}] // Ashley Black's KryoPack™ Back & Abs Wrap
    }
},
 {
  bundle_name: 'FUPA Be Gone Kit',
  bundle_class: 'FUPA_Be_Gone_Kit',
  sold: false,
  bundle_discount: 19.5439739,
  bundle_components: [
    {id: 32994645409885, price:59.00}, // Ashley Black's KryoPack™ Wrap
    {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00}, // FasciaBlaster® Nugget
    {id: 32954698301533, price:195.00} // MINI PADDLEBLASTER®
  ]
},
 {
  bundle_name: 'Face Duo Kit',
  bundle_class: 'Face_Duo_Kit',
  sold: false,
  bundle_discount: 31.6091954,
  bundle_components: [
    {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
    {id: 39330949726301, price:59.00} // Ashley Black's Kryopack™ Face Wrap
  ]
},
// 4 types of cellulite kits
{
  bundle_name: 'Hail Damage Kit',
  bundle_class: 'Hail_Damage_Kit',
  sold: false,
  bundle_discount: 15.9235669,
  bundle_components: [
    {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
    {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00} // Mini 2™
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [{id: 28922827112541, price:15.00}] // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
  }
},
{
  bundle_name: 'Gummy Kit',
  bundle_class: 'Gummy_Kit',
  sold: false,
  bundle_discount: 24.5700246,
  bundle_components: [
    {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
    {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
    {id: 39412987887709, price:53.00, replace_variant: 39412987920477, replace_price: 53.00} // FasciaBlaster® Nugget
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [{id: 28922827112541, price:15.00}] // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
  }
},
{
  bundle_name: 'Beyond Bound Kit',
  bundle_class: 'Beyond_Bound_Kit',
  sold: false,
  bundle_discount: 32.7543424,
  bundle_components: [
    {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price:195}, // MasterBlaster™
    {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
    {id: 39412987887709, price:53.00, replace_variant: 39412987920477, replace_price: 53.00} // FasciaBlaster® Nugget
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [{id: 28922827112541, price:15.00}] // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
  }
},
{
  bundle_name: 'Car Wreck Kit',
  bundle_class: 'Car_Wreck_Kit',
  sold: false,
  bundle_discount: 16.1290323,
  bundle_components: [
    {id: 32954698301533, price:195.00}, // MINI PADDLEBLASTER®
    {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00} // Mini 2™
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [{id: 28922827112541, price:15.00}] // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
  }
},
// Black Friday 2022 Kits
{
  bundle_name: 'FasciaBlaster Wrap Duo',
  bundle_class: 'FasciaBlaster_Wrap_Duo',
  sold: false,
  bundle_discount: 10.3225806,
  bundle_components: [
    {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00} // FasciaBlaster®
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 32994645409885, price:59.00} // Ashley Black's KryoPack™ Wrap
    ]
  }
},
{
  bundle_name: 'MasterBlaster Wrap Duo',
  bundle_class: 'MasterBlaster_Wrap_Duo',
  sold: false,
  bundle_discount: 20.5128205,
  bundle_components: [
    {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price:195} // MasterBlaster™
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 32994645409885, price:59.00} // Ashley Black's KryoPack™ Wrap
    ]
  }
},
{
  bundle_name: 'MasterBlaster Spot Duo',
  bundle_class: 'MasterBlaster_Spot_Duo',
  sold: false,
  bundle_discount: 20.5128205,
  bundle_components: [
    {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price:195} // MasterBlaster™
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ]
  }
},
{
  bundle_name: 'BigDaddy Wrap Duo',
  bundle_class: 'BigDaddy_Wrap_Duo',
  sold: false,
  bundle_discount: 23.6453202,
  bundle_components: [
    {id: 39412928938077, price:203.00, replace_variant: 39412928905309, replace_price:203.00} // BigDaddy FasciaBlaster®
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 32994645409885, price:59.00} // Ashley Black's KryoPack™ Wrap
    ]
  }
},
{
  bundle_name: 'BigDaddy Spot Duo',
  bundle_class: 'BigDaddy_Spot_Duo',
  sold: false,
  bundle_discount: 23.6453202,
  bundle_components: [
    {id: 39412928938077, price:203.00, replace_variant: 39412928905309, replace_price:203.00} // BigDaddy FasciaBlaster®
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ]
  }
},
{
  bundle_name: 'ProBlaster Wrap Duo',
  bundle_class: 'ProBlaster_Wrap_Duo',
  sold: false,
  bundle_discount: 30.1507538,
  bundle_components: [
    {id: 40388692410461, price:199.00} // ProBlaster™️️️️️️
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 32994645409885, price:59.00} // Ashley Black's KryoPack™ Wrap
    ]
  }
},
{
  bundle_name: 'ProBlaster Spot Duo',
  bundle_class: 'ProBlaster_Spot_Duo',
  sold: false,
  bundle_discount: 30.1507538,
  bundle_components: [
    {id: 40388692410461, price:199.00} // ProBlaster™️️️️️️
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ]
  }
},
{
  bundle_name: 'Mini Paddle Wrap Duo',
  bundle_class: 'Mini_Paddle_Wrap_Duo',
  sold: false,
  bundle_discount: 10.2564103,
  bundle_components: [
    {id: 32954698301533, price:195.00} // MINI PADDLEBLASTER®
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 32994645409885, price:59.00} // Ashley Black's KryoPack™ Wrap
    ]
  }
},
{
    bundle_name: 'Brush And Blast Kit',
    bundle_class: 'Brush_And_Blast_Kit',
    sold: false,
    bundle_discount: 50, 
    bundle_components: [
      {id: 40753524998237, price: 256.00}, // Blaster Base
      {id: 40753525031005, price: 148.00, qty: 2} // Brush booster
   ]
},
{
  bundle_name: 'NYNY Just Get Started Kit',
  bundle_class: 'NYNY_Just_Get_Started_Kit',
  sold: false,
  bundle_discount: 28.1632653, 
  bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 28922827112541, price:15.00}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00} // Mini 2™
   ]
},
{
bundle_name: 'NYNY Upgraded Kit',
bundle_class: 'NYNY_Upgraded_Kit',
sold: false,
bundle_discount: 32.173913, 
bundle_components: [
  {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
  {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
  {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00}, // FasciaBlaster® Nugget
  {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
  {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
 ]
},
{
bundle_name: 'NYNY Luxury Kit',
bundle_class: 'NYNY_Luxury_Kit',
sold: false,
bundle_discount: 35.0832266, 
bundle_components: [
  {id: 40753524998237, price: 256.00}, // Blaster Base
  {id: 40753525031005, price: 148.00, qty: 2}, // Brush booster
  {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
  {id: 39309566869597, price:99.00}, // Ashley Black's Kryomat™ Small
  {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
 ]
},
{
  bundle_name: 'Face Duo',
  bundle_class: 'Face_Duo',
  sold: false,
  bundle_discount: 35,
  bundle_components: [
    {id: 40464298377309, price:243.00}, // OMGBlaster
    {id: 39330949726301, price:59.00} // Ashley Black's Kryopack™ Face Wrap
  ]
},
{
  bundle_name: 'Muscles Kit',
  bundle_class: 'muscles_kit',
  sold: false,
  bundle_discount: 35.2173913,
  bundle_components: [
    {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
    {id: 39309566869597, price:99.00}, // Ashley Black's Kryomat™ Small
    {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00}, // FasciaBlaster® Nugget
    {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
    {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00} // FasciaBlaster®
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Mini Kit',
  bundle_class: 'Mini_Kit',
  sold: false,
  bundle_discount: 25.7462687,
  bundle_components: [
    {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
    {id: 39412991688797, price:115.00, replace_variant: 39412991656029, replace_price: 115.00}, // Mini 2™
    {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
  ]
},
{
  bundle_name: 'Sensitive Skin Starter Kit',
  bundle_class: 'Sensitive_Skin_Starter_Kit',
  sold: false,
  bundle_discount: 24.4827586,
  bundle_components: [
    {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
    {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00}, // FasciaBlaster® Nugget
    {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
  ]
},
{
  bundle_name: 'Onyx Kit',
  bundle_class: 'Onyx_Kit',
  sold: false,
  bundle_discount: 45.0570342,
  bundle_components: [
    {id: 39412928938077, price: 203.00, replace_variant: 39412928905309, replace_price: 203.00}, // BigDaddy FasciaBlaster®
    {id: 39412931952733, price: 155.00, replace_variant: 39412931919965, replace_price: 155.00}, // FasciaBlaster® Extenders
    {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
    {id: 39412987920477, price: 53.00, replace_variant: 39412987887709, replace_price: 53.00} // FasciaBlaster® Nugget
  ]
},
{
  bundle_name: 'Bare Bones Kit',
  bundle_class: 'Bare_Bones_Kit',
  sold: false,
  bundle_discount: 30.1507538,
  bundle_components: [
    {id: 40388692410461, price:199.00} // ProBlaster™️️️️️️
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Cellulite Quick Start Kit',
  bundle_class: 'Cellulite_Quick_Start_Kit',
  sold: false,
  bundle_discount: 31.7596567,
  bundle_components: [
    {id: 32954698301533, price:195.00}, // MINI PADDLEBLASTER®
    {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Cellulite Upgraded Kit',
  bundle_class: 'Cellulite_Upgraded_Kit',
  sold: false,
  bundle_discount: 36.7670365,
  bundle_components: [
      {id: 40753524998237, price: 256.00}, // Blaster Base
      {id: 40753525031005, price: 148.00, qty: 2}, // Brush booster
      {id: 32996096737373, price:79.00} // Ashley Black's KryoPack™ Back & Abs Wrap
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Cellulite Luxury Kit',
  bundle_class: 'Cellulite_Luxury_Kit',
  sold: false,
  bundle_discount: 40,
  bundle_components: [
      {id: 40753524998237, price: 256.00}, // Blaster Base
      {id: 40753525031005, price: 148.00, qty: 2}, // Brush booster
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
      {id: 39309566869597, price:99.00} // Ashley Black's Kryomat™ Small
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Face and Neck Quick Start Kit',
  bundle_class: 'Face_and_Neck_Quick_Start_Kit',
  sold: false,
  bundle_discount: 31.6091954,
  bundle_components: [
    {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
    {id: 39330949726301, price:59.00} // Ashley Black's Kryopack™ Face Wrap
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Maintenance Quick Start Kit',
  bundle_class: 'Maintenance_Quick_Start_Kit',
  sold: false,
  bundle_discount: 36.0795455,
  bundle_components: [
    {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
    {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
    {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Maintenance Upgraded Kit',
  bundle_class: 'Maintenance_Upgraded_Kit',
  sold: false,
  bundle_discount: 42.9460581,
  bundle_components: [
    {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
    {id: 32954698301533, price:195.00}, // MINI PADDLEBLASTER®
    {id: 39412987920477, price: 53.00, replace_variant: 39412987887709, replace_price: 53.00}, // FasciaBlaster® Nugget
    {id: 32996096737373, price:79.00} // Ashley Black's KryoPack™ Back & Abs Wrap
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Maintenance Luxury Kit',
  bundle_class: 'Maintenance_Luxury_Kit',
  sold: false,
  bundle_discount: 47.4053296,
  bundle_components: [
    {id: 40753524998237, price: 256.00}, // Blaster Base
    {id: 39412928938077, price: 203.00, replace_variant: 39412928905309, replace_price: 203.00}, // BigDaddy FasciaBlaster®
    {id: 39412931952733, price: 155.00, replace_variant: 39412931919965, replace_price: 155.00}, // FasciaBlaster® Extenders
    {id: 39309566869597, price:99.00} // Ashley Black's Kryomat™ Small
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Introduction Quick Start Kit',
  bundle_class: 'Introduction_Quick_Start_Kit',
  sold: false,
  bundle_discount: 30.2238806,
  bundle_components: [
    {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
    {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
    {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Introduction Upgraded Kit',
  bundle_class: 'Introduction_Upgraded_Kit',
  sold: false,
  bundle_discount: 35.1851852,
  bundle_components: [
    {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
    {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
    {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00}, // FasciaBlaster® Nugget
    {id: 32996096737373, price:79.00} // Ashley Black's KryoPack™ Back & Abs Wrap
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Introduction Luxury Kit',
  bundle_class: 'Introduction_Luxury_Kit',
  sold: false,
  bundle_discount: 40.17991,
  bundle_components: [
    {id: 40753524998237, price: 256.00}, // Blaster Base
    {id: 40753525031005, price: 148.00, qty: 2}, // Brush booster
    {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00} // Mini 2™
  ], free_components: {
    bundle_percentage: 100,
    free_bundle_componets: [
      {id: 28922827112541, price:15.00} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  }
},
{
  bundle_name: 'Hair Upgraded Kit',
  bundle_class: 'Hair_Upgraded_Kit',
  sold: false,
  bundle_discount: 30.8695652,
  bundle_components: [
    {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
    {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00} // Mini 2™
  ]
},
  {
    bundle_name: 'Blaster Pod',
    bundle_class: 'Blaster_Pod_Kit',
    sold: false,
    bundle_discount: 20.7039337, 
    bundle_components: [
      {id: 39695149695069, price:483.00} // Ashley Black's™ Blaster Pod™ for Feet
    ]
  },
  {
    bundle_name: 'Starter Foot Kit',
    bundle_class: 'Starter_Foot_Kit',
    sold: false,
    bundle_discount: 40.9836066, 
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 32994246590557, price:129.00} // Mini 1™
    ]
  },
  {
    bundle_name: 'Small Tool Kit',
    bundle_class: 'Small_Tool_Kit',
    sold: false,
    bundle_discount: 40.4761905, 
    bundle_components: [
      {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 40753525031005, price: 148.00} // Brush booster
    ]
  },
  {
    bundle_name: 'Big Tool Kit',
    bundle_class: 'Big_Tool_Kit',
    sold: false,
    bundle_discount: 40.087146, 
    bundle_components: [
      {id: 39412928938077, price: 203.00, replace_variant: 39412928905309, replace_price: 203.00}, // BigDaddy FasciaBlaster®
      {id: 40753524998237, price: 256.00} // Blaster Base
    ]
  },
  {
    bundle_name: 'Dual ProBlaster',
    bundle_class: 'Dual_ProBlaster',
    sold: false,
    not_single_product: true,
    bundle_discount: 50,
    bundle_components: [
      {id: 40388692410461, price: 199.00, qty: 2} // ProBlaster™️️️️️️
    ]
  },
  {
    bundle_name: 'Skin Rejuvenation Kit',
    bundle_class: 'Skin_Rejuvenation_Kit',
    sold: false,
    bundle_discount: 35.4368932,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
      {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00} // FasciaBlaster® Nugget
    ]
  },
  {
    bundle_name: 'Starter Kit',
    bundle_class: 'Starter_Kit',
    sold: false,
    bundle_discount: 30.2547771,
    bundle_components: [
      {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00} // Mini 2™
    ]
  },
  {
    bundle_name: 'Luxe Kit',
    bundle_class: 'Luxe_Kit',
    sold: false,
    bundle_discount: 40.0576369,
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 40753524998237, price: 256.00}, // Blaster Base
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00} // FasciaBlaster® Nugget
    ]
  },
  {
    bundle_name: 'Dynamic Duo',
    bundle_class: 'Dynamic_Duo',
    sold: false,
    bundle_discount: 35.1485149,
    bundle_components: [
      {id: 40753525031005, price: 148.00}, // Brush booster
      {id: 40753524998237, price: 256.00} // Blaster Base
    ]
  },
  {
    bundle_name: 'Summer Body Kit',
    bundle_class: 'Summer_Body_Kit',
    sold: false,
    bundle_discount: 40.0662252,
    bundle_components: [
      {id: 39412928938077, price:203.00, replace_variant: 39412928905309, replace_price:203.00}, // BigDaddy FasciaBlaster®
      {id: 39309566869597, price:99.00} // Ashley Black's Kryomat™ Small
    ]
  },
  {
    bundle_name: 'OMGBlaster_Kit',
    bundle_class: 'OMGBlaster_Kit',
    sold: false,
    bundle_discount: 30.4526749,
    bundle_components: [
      {id: 40464298377309, price:243.00} // OMGBlaster
    ]
  },
  {
    bundle_name: 'OMG Kit',
    bundle_class: 'OMG_Kit',
    sold: false,
    bundle_discount: 45.0704225,
    bundle_components: [
      {id: 40464298377309, price:243.00}, // OMGBlaster
      {id: 39330949791837, price:59.00}, // Ashley Black's Kryopack™ Eye Wrap
      {id: 39412987920477, price: 53.00, replace_variant:39412987887709 , replace_price: 53.00} // FasciaBlaster® Nugget
    ]
  },
  {
    bundle_name: 'Trauma Kit',
    bundle_class: 'Trauma_Kit',
    sold: false,
    bundle_discount: 45.0686642,
    bundle_components: [
      {id: 40753524998237, price: 256.00}, // Blaster Base
      {id: 40753525031005, price: 148.00, qty: 2}, // Brush booster
      {id: 39330949922909, price:249.00} // Ashley Black's Kryomat™ Medium
    ]
  },
  {
    bundle_name: 'Nugget Large Kit',
    bundle_class: 'Nugget_Large_Kit',
    sold: false,
    bundle_discount: 50.1113586,
    bundle_components: [
      {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00}, // FasciaBlaster® Nugget
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 32996102176861, price:38.00}, // Ashley Black's KryoPack™ Spot
      {id: 40464298377309, price:243.00} // OMGBlaster
    ]
  },
  {
    bundle_name: 'Nugget Small Kit',
    bundle_class: 'Nugget_Small_Kit',
    sold: false,
    bundle_discount: 35.1190476,
    bundle_components: [
      {id: 39412987887709, price: 53.00, replace_variant: 39412987920477, replace_price: 53.00}, // FasciaBlaster® Nugget
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00} // Mini 2™
    ]
  },
  {
    bundle_name: 'The Longevity Kit',
    bundle_class: 'The_Longevity_Kit_BDaySale',
    sold: false,
    bundle_discount: 52.0865533,
    bundle_components: [
      {id: 39412928938077, price:203.00, replace_variant: 39412928905309, replace_price:203.00}, // BigDaddy FasciaBlaster®
      {id: 32954698301533, price:195.00}, // MINI PADDLEBLASTER®
      {id: 39330949922909, price:249.00} // Ashley Black's Kryomat™ Medium
    ]
  },
  {
    bundle_name: 'The Beginner Kit',
    bundle_class: 'The_Birthday_Beginner_Kit',
    sold: false,
    bundle_discount: 52.0775623,
    bundle_components: [
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412990902365, price:115.00, replace_variant: 39412990869597, replace_price: 115.00}, // FaceBlaster™
      {id: 39412987920477, price: 53.00, replace_variant: 39412987887709, replace_price: 53.00}, // FasciaBlaster® Nugget
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ]
  },
  {
    bundle_name: 'The Master Blaster Kit',
    bundle_class: 'Master_Blaster_Birthday_Kit',
    sold: false,
    bundle_discount: 52.18509,
    bundle_components: [
      {id: 39412992016477, price:195.00, replace_variant: 39412992049245, replace_price: 195.00}, // MasterBlaster™
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 32996096737373, price:79.00} // Ashley Black's KryoPack™ Back & Abs Wrap
    ]
  },
  {
    bundle_name: 'Face Kit',
    bundle_class: 'Face_Kit',
    sold: false,
    bundle_discount: 61.6504854,
    bundle_components: [
      {id: 39412990902365, price:115.00, replace_variant: 39412990869597, replace_price: 115.00}, // FaceBlaster™
      {id: 39412987920477, price: 53.00, replace_variant: 39412987887709, replace_price: 53.00}, // FasciaBlaster® Nugget
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ]
  },
  {
    bundle_name: 'Layers by Layer Kit',
    bundle_class: 'Layer_by_Layer_Kit',
    sold: false,
    bundle_discount: 60.0767754,
    bundle_components: [
      {id: 40753525031005, price: 148.00}, // Brush booster
      {id: 40388692410461, price:199.00}, // ProBlaster™️️️️️️
      {id: 39412991656029, price:115.00, replace_variant: 39412991688797, replace_price: 115.00}, // Mini 2™
      {id: 32994645409885, price:59.00} // Ashley Black's KryoPack™ Wrap
    ]
  }
];


var upsell_bundles_array = [
  {
    bundle_name: 'Beginner Kit',
    bundle_class: 'Beginner_Kit',
    sold: false,
    bundle_discount: 38.5844749,
  bundle_original_price: 438.00,
  bundle_discounted_price: 269.00,
  bundle_description: " ",
    bundle_components: [
      {id: 39412898365533, price:155.00, replace_variant: 39412898398301, replace_price: 155.00}, // FasciaBlaster®
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991688797, price:115.00, replace_variant: 39412991656029, replace_price: 115.00}, // Mini 2™
      {id: 28922827112541, price:15.00}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ]
  },
  {
    bundle_name: 'Budget Box',
    bundle_class: 'Budget_Box',
    sold: false,
    bundle_discount: 38.1625442,
  bundle_original_price: 283.00,
  bundle_discounted_price: 175.00,
  bundle_description: " ",
    bundle_components: [
      {id: 39412990869597, price:115.00, replace_variant: 39412990902365, replace_price: 115.00}, // FaceBlaster™
      {id: 39412991688797, price:115.00, replace_variant: 39412991656029, replace_price: 115.00}, // Mini 2™
      {id: 28922827112541, price:15.00}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      {id: 32996102176861, price:38.00} // Ashley Black's KryoPack™ Spot
    ]
  }
];


// if id null, select 3 display by most expensive
const bundles_per_handle = {
  39412991688797: ["Beginner_Kit"]
  //32669289447520: ['Celebrity_Kit', "Onyx_Initiator_Kit", "Platinum_Pack", "Budget_Box", 'Quick_Start_Kit', 'De-Stress_Pack', 'Celebrity_Kit']
};

const bundle_upsell = { Beginner_Kit: ["Platinum_Pack", "Back_Pack"]};

const subscribtion_products = [
  {variant_id: 32669495459936, name: 'Ashley Black\'s ™ Deluxe Serum', handle:'deluxe-serum'},
  {variant_id: 19825070506080, name: '3.5 OZ AfterBlaster Cream™', handle: 'small-afterblaster-cream'},
  {variant_id: 32669289447520, name: 'Roll On Blaster Oil', handle:'roll-on-blaster-oil'},
  {variant_id: 36058796684, name: 'FaceCare Essentials Kit', handle:'facekit-products'},
  {variant_id: 2474685038604, name: '12 OZ Blaster Oil®', handle:'12-oz-blaster-oil'},
  {variant_id: 19824951165024, name: '3.4 OZ Blaster Oil®', handle:'small-oz-blaster-oil'}
];

var fake_product_name = {};

var discount_products_base_on_qty = {};
var bf_2022_sale = {};
var bundle_description = {
  "MasterBlaster_Wrap_Duo": "<p>The ultimate prep tool used with light pressure and advanced tool with deeper pressure. Use as a prep tool, light and brisk at the surface layer of the skin. Use as a refining tool using the advanced techniques. The MasterBlaster™ combines the detailed approach of the FaceBlaster™ with the reach of the original FasciaBlaster®. It comes with 9 small claws and a sleek, lightweight bar for full body ultimate coverage.</p><p>Plus free gift:</p><ul><li>Ashley Black's Kryopack™ Wrap</li></ul>",
  "BigDaddy_Wrap_Duo": "<p>The BigDaddy FasciaBlaster® is similar to the original FasciaBlaster®, but we've added two additional original-sized claws! The extra claws allow for added coverage on large areas, and the longer bar gives you a wider grip to allow for easier use on areas like your back. Imagine being able to temporarily increase blood flow to your own back and legs. The larger claws allow you to push deeper into the muscle tissue with ease. Give yourself a skilled fascia massage on a regular basis!</p><p>Plus free gift:</p><ul><li>Ashley Black's Kryopack™ Wrap</li></ul>",
  "FasciaBlaster_Wrap_Duo": "<p>The FasciaBlaster® by Ashley Black is the #1 selling self-massage myofascial tool for massaging your tissue. The FasciaBlaster® was designed, engineered, and manufactured by Ashley Black and can massage fascia and muscles on almost any area of the body. The larger claws allow you to push deeper into the muscle tissue with ease. Imagine the benefits of being able to temporarily increase blood flow to each area of your body. Give yourself a skilled fascia massage on a regular basis. Added bonus, the FasciaBlaster® temporarily lessens the appearance of cellulite.</p><p>Plus free gift:</p><ul><li>Ashley Black's Kryopack™ Wrap</li></ul>",
  "ProBlaster_Wrap_Duo": "<p>The ProBlaster™️️️️️️ is FasciaBlasting in the palm of your hand (literally)! With medical grade silicone for a soft grip and two rows of mini claws, it's powerful, yet GENTLE.</p><p>Plus free gift:</p><ul><li>Ashley Black's Kryopack™ Wrap</li></ul>",
  "Mini_Paddle_Wrap_Duo": "<p>The Mini PaddleBlaster with Flusher is an incredible new technology! 9 mini claws in 3 rows with an easy to use handle to make arms, legs, abs, and over the neck and shoulder area soooo easy!</p><p>The NEW FEATURE is the “flushing mechanism” which allows you to “scan” down muscles to find your fascial problems! Then use the flusher at the end up and down to get the fluids flowing and complete your Blaster session!</p><p>This season MUST HAVE.</p><p>Plus free gift:</p><ul><li>Ashley Black's Kryopack™ Wrap</li></ul>",
  "BigDaddy_Spot_Duo": "<p>The BigDaddy FasciaBlaster® is similar to the original FasciaBlaster®, but we've added two additional original-sized claws! The extra claws allow for added coverage on large areas, and the longer bar gives you a wider grip to allow for easier use on areas like your back. Imagine being able to temporarily increase blood flow to your own back and legs. The larger claws allow you to push deeper into the muscle tissue with ease. Give yourself a skilled fascia massage on a regular basis!</p><p>Plus free gift:</p><ul><li>Ashley Black's Kryopack™ Spot</li></ul>",
  "MasterBlaster_Spot_Duo": "<p>The ultimate prep tool used with light pressure and advanced tool with deeper pressure. Use as a prep tool, light and brisk at the surface layer of the skin. Use as a refining tool using the advanced techniques. The MasterBlaster™ combines the detailed approach of the FaceBlaster™ with the reach of the original FasciaBlaster®. It comes with 9 small claws and a sleek, lightweight bar for full body ultimate coverage.</p><p>Plus free gift:</p><ul><li>Ashley Black's Kryopack™ Spot</li></ul>",
  "ProBlaster_Spot_Duo": "<p>The ProBlaster™️️️️️️ is FasciaBlasting in the palm of your hand (literally)! With medical grade silicone for a soft grip and two rows of mini claws, it's powerful, yet GENTLE.</p><p>Plus free gift:</p><ul><li>Ashley Black's Kryopack™ Spot</li></ul>",
  "Brush_And_Blast_Kit": "<ul> <li>Brush Booster - With one side for lymphatic drainage, and the other to plump the surface capillaries for youthful skin</li> <li>Blaster Base - Our universal small claw Blaster that houses Blaster Boosters</li> </ul>",
  "NYNY_Just_Get_Started_Kit": "<ul> <li>Faceblaster - For sculpting the face and little spots, like the knees</li> <li>Blaster Base - Our universal small claw Blaster that houses Blaster Boosters</li> <li>Cellulite Myth Book - Our #1 National Best Seller Fascia Bible</li> </ul>",
  "NYNY_Upgraded_Kit": "<ul> <li>Problaster - Our most gentle and intuitive tool yet</li> <li>Fasciablaster - For deep myofascial blasting</li> <li>Nugget - Trigger point therapy</li> <li> Spot Kryo Pack - For soothing kryotherapy</li> <li>Cellulite Myth Book - Our #1 National Best Seller Fascia Bible</li> </ul>",
  "NYNY_Luxury_Kit": "<ul> <li>Brush Booster - With one side for lymphatic drainage, and the other to plump the surface capillaries for youthful skin</li> <li>Blaster Base - Our universal small claw Blaster that houses Blaster Boosters</li> <li>Problaster - Our most gentle and intuitive tool yet</li> <li>Mini 2 - For deep myofascial and trigger point therapy</li> <li>Small Kryo Mat: For soothing kryotherapy</li> <li>Cellulite Myth Book - Our #1 National Best Seller Fascia Bible</li> </ul>"
};
var cart_gift_products = {
  // 'plastic-nugget': {
  //   'id': 39412987887709,
  //   'name': "FasciaBlaster® Nugget White",
  //   'price': 53.00
  // },
  'plastic-nugget': {
    'id': 39412987920477,
    'name': "FasciaBlaster® Nugget Black",
    'price': 53.00
  },
  'ashley-blacks-jaw-small-area-wrap-kryopack': {
    'id': 39330949824605,
    'name': "Ashley Black’s Kryopack™ Jaw/small Area Wrap",
    'price': 79.00
  },
  'ashley-blacks-back-and-abs-wrap-kryopack': {
    'id': 32996096737373,
    'name': "Ashley Black’s KryoPack™ Back & Abs Wrap",
    'price': 79.00
  },
  'ashley-blacks-face-wrap-kryopack': {
    'id': 39330949726301,
    'name': "Ashley Black's Kryopack™ Face Wrap",
    'price': 59.00
  },
  'ashley-blacks-wrap-kryopack': {
    'id': 32996102176861,
    'name': "Ashley Black’s KryoPack™ Spot",
    'price': 38.00
  }
}
